export function question() {
  const box = document.querySelector(".p-top-chart__box");

  // HTMLの data 属性から画像パスを取得
  const imagePaths = {
    "ガイア": box.dataset.imgGaia,
    "Jobs": box.dataset.imgJobs,
    "ヤメドキ": box.dataset.imgYamedoki,
    "ガーディアン": box.dataset.imgGuardian,
    "トリケシ": box.dataset.imgTorikeshi,
  };

  // あとは今まで通りでOK！
  const resultMap = {
    "ガイア": {
      text: "弁護士に依頼できる<br>④ガイア",
      link: "https://www.gaia-law-office.jp/taisyoku/index.html",
    },
    "Jobs": {
      text: "相談〜交渉できる<br>即日退職連絡も可能<br>①Jobs",
      link: "https://ad.resultplus2.jp/cf26S373Sef9aai9/cl/?bId=C2b79ao8",
    },
    "ヤメドキ": {
      text: "追加表で弁護士連携<br>②ヤメドキ",
      link: "https://www.rentracks.jp/adx/r.html?idx=0.28877.358786.9372.13314&dna=155305",
    },
    "ガーディアン": {
      text: "返金保証がないけど<br>低価格<br>③ガーディアン",
      link: "https://taisyokudaiko.jp/lp4/",
    },
    "トリケシ": {
      text: "シンプルなプラン<br>⑤トリケシ",
      link: "https://v3.torikeshi.jp/3242",
    },
  };

  // 以下は今までの質問・分岐ロジックそのままでOK
  let currentStep = 0;

  function renderQuestion(step) {
    const title = box.querySelector(".p-top-chart__box-text-title");
    const buttons = box.querySelectorAll(".p-top-chart__box-btn");

    const data = chartData[step];

    title.textContent = data.title;
    buttons[0].textContent = data.blueText;
    buttons[1].textContent = data.redText;

    buttons[0].onclick = () => handleNext(data.next[0]);
    buttons[1].onclick = () => handleNext(data.next[1]);
  }

  function handleNext(next) {
    if (typeof next === "number") {
      renderQuestion(next);
    } else {
      showResult(next);
    }
  }

  function showResult(key) {
    const title = box.querySelector(".p-top-chart__box-text-title");
    const btnWrap = box.querySelector(".p-top-chart__box-btn-wrap");
    const icon = box.querySelector(".p-top-chart__box-text-icon");

    const result = resultMap[key];
    title.innerHTML = result.text;

    if (icon) icon.style.display = 'none';

    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'p-top-chart__box-image-wrapper';

    const imageElement = document.createElement('img');
    imageElement.src = imagePaths[key];
    imageElement.alt = `${key} image`;

    imageWrapper.appendChild(imageElement);
    box.insertBefore(imageWrapper, btnWrap);

    btnWrap.innerHTML = `
      <a href="${result.link}" class="p-top-chart__box-link c-btn" target="_blank">
        公式ページを見る<span class="p-top-chart__box-link-arrow c-btn__arrow"></span>
      </a>
    `;
  }

  const chartData = [
    {
      title: "退職についてのお気持ち",
      blueText: "スムーズに辞めたい",
      redText: "会社を訴えたい",
      next: [1, "ガイア"]
    },
    {
      title: "退職または、できるだけ早く辞めたい。",
      blueText: "はい",
      redText: "いいえ",
      next: ["Jobs", 2]
    },
    {
      title: "手厚いサービス・サポートは必要ない",
      blueText: "はい、不要です",
      redText: "必要、あった方が良い",
      next: ["トリケシ", 3]
    },
    {
      title: "退職代行サービスで本当に辞められるか心配",
      blueText: "はい",
      redText: "いいえ",
      next: [4, "ガーディアン"]
    },
    {
      title: "もしものトラブルでは弁護士と連携したい",
      blueText: "はい",
      redText: "いいえ",
      next: ["ヤメドキ", "Jobs"]
    }
  ];

  renderQuestion(currentStep);
}
